import { Box, Link, Typography } from "@mui/material";
import { OpenInNew as OpenInNewIcon } from "@mui/icons-material";
import { DynamicIcon } from "~/components/icons/DynamicIcon";
import { Icon_Ids } from "~/operations";
import { useColorMode } from "~/providers/color-mode";

export type SourceLink = {
  href: string;
  text: string;
  icon?: Icon_Ids | null;
};

export type SourcesProps = {
  links: SourceLink[];
  id?: string;
  showTitle?: boolean;
};

export function Sources({ links, id, showTitle = true }: SourcesProps) {
  const { mode } = useColorMode();

  return (
    <Box id={id}>
      {showTitle && links.length > 0 && (
        <Typography textTransform="uppercase" fontWeight={700} mb={1}>
          Learn More
        </Typography>
      )}
      <Box component="ul" sx={{ pl: 0, listStyle: "none" }}>
        {links.map((link, i) => (
          <Box
            component="li"
            key={i}
            display="flex"
            alignItems="center"
            gap={1}
          >
            {link.icon && <DynamicIcon iconId={link.icon} />}
            <Link
              href={link.href}
              target="_blank"
              fontWeight={600}
              lineHeight={2}
              color={mode === "light" ? "secondary.main" : "secondary.light"}
              display="inline-flex"
              alignItems="center"
              gap={1}
            >
              {link.text} <OpenInNewIcon fontSize="inherit" />
            </Link>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
